const CUSTOMER_PAYROLL_STATUS = {
  PENDING: "pending",
  FAILED: "failed",
  PAID: "paid",
  UNPAID: "un-paid",
  FINALIZED: "finalized",
  VOID: "void",
};

export default CUSTOMER_PAYROLL_STATUS;
